<section class="gallery-wrap" aria-label="Saved designs">
  <header class="gallery-head">
    <h2>Gallery</h2>
    <span class="count">{{ designs.length }} design{{ designs.length === 1 ? '' : 's' }}</span>
  </header>

  <div class="filters" role="group" aria-label="Filter designs" *ngIf="designs.length">
    <button type="button" [class.on]="filter === 'all'" (click)="setFilter('all')"
            [attr.aria-pressed]="filter === 'all'">All</button>
    <button type="button" [class.on]="filter === 'animated'" (click)="setFilter('animated')"
            [attr.aria-pressed]="filter === 'animated'">Animated</button>
    <button type="button" [class.on]="filter === 'still'" (click)="setFilter('still')"
            [attr.aria-pressed]="filter === 'still'">Still</button>
  </div>

  <p class="empty" *ngIf="!designs.length">
    Nothing saved yet. Draw something, name it, and hit Save — it'll show up here for anyone to send to the board.
  </p>

  <div class="tiles" *ngIf="designs.length">
    <button *ngFor="let d of visible; trackBy: trackByDesign" type="button" class="tile"
            [class.sel]="d === selected" (click)="select(d)" [attr.aria-pressed]="d === selected">
      <span class="thumb-wrap">
        <img class="thumb" [src]="d.thumbnail" [alt]="d.name" />
        <span class="badge" *ngIf="isAnimated(d)">▶ {{ frameCount(d) }}</span>
        <span class="check" *ngIf="d === selected" aria-hidden="true">✓</span>
      </span>
      <span class="name">{{ d.name }}</span>
    </button>
  </div>
</section>

<div class="picked-scrim" *ngIf="selected" (click)="close()"></div>

<div class="picked" *ngIf="selected">
  <div class="grabber" aria-hidden="true"></div>
  <div class="picked-head">
    <img class="picked-thumb" [src]="selected.thumbnail" [alt]="selected.name" />
    <div class="picked-text">
      <div class="picked-name">{{ selected.name }}</div>
      <div class="picked-sub">{{ summary(selected) }}</div>
    </div>
    <button type="button" class="close" (click)="close()" aria-label="Close">✕</button>
  </div>
  <div class="picked-actions">
    <button type="button" class="edit" (click)="editSelected()">✏️ Edit a copy</button>
    <button type="button" class="send" [disabled]="sending" (click)="sendSelected()">
      {{ sending ? 'Sending…' : '📡 Send to board' }}
    </button>
  </div>
</div>
